import moment, { Moment } from 'moment';
import React, { useMemo } from 'react';
import { StyledRadio, StyledRadioGroup, StyledRadioTab } from './styles';

type Values = 'all' | 'oneweek' | 'onemonth' | 'threemonth';

interface Props {
  formatString?: string;
  fromDate?: string;
  toDate?: string;
  dateValue: {
    startDate: string;
    endDate: string;
  };
  onChange: (value: {
    selector: Values;
    startDate: {
      string: string;
      date: Date;
      default: Moment;
    };
    endDate: {
      string: string;
      date: Date;
      default: Moment;
    };
  }) => void;
}

const DateRangeRadio = ({
  fromDate,
  toDate,
  dateValue,
  formatString = 'YYYY-MM-DD',
  onChange,
}: Props) => {
  const getStartDate = (type: Values) => {
    let startDate = moment().subtract(1, 'months');

    if (type === 'all') {
      startDate = moment(fromDate ? fromDate : '1990-01-01');
    } else if (type === 'oneweek') {
      startDate = moment().subtract(6, 'days');
    } else if (type === 'onemonth') {
      startDate = moment().subtract(1, 'months');
    } else if (type === 'threemonth') {
      startDate = moment().subtract(3, 'months');
    }

    return startDate;
  };

  const changeHandler = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const value = ev.target.value as Values;
    const startDate = getStartDate(value);
    const endDate = moment(toDate ? toDate : undefined);

    onChange({
      selector: value,
      startDate: {
        date: startDate.toDate(),
        default: startDate,
        string: startDate.format(formatString),
      },
      endDate: {
        date: endDate.toDate(),
        default: endDate,
        string: endDate.format(formatString),
      },
    });
  };

  const pickRange = useMemo(() => {
    const diff = moment(moment().toDate()).diff(dateValue.startDate, 'd');
    if (diff === 6) return 'oneweek';
    if (diff === 28 || diff === 30 || diff === 31) return 'onemonth';
    if (diff === 90) return 'threemonth';
    return 'all';
  }, [dateValue]);

  return (
    <StyledRadioGroup>
      <ul>
        <StyledRadio>
          <label>
            <input
              type="radio"
              name="date-range-radio"
              value="all"
              checked={pickRange === 'all'}
              onChange={changeHandler}
            />
            <StyledRadioTab>All</StyledRadioTab>
          </label>
        </StyledRadio>
        <StyledRadio>
          <label>
            <input
              type="radio"
              name="date-range-radio"
              value="oneweek"
              checked={pickRange === 'oneweek'}
              onChange={changeHandler}
            />
            <StyledRadioTab>1Week</StyledRadioTab>
          </label>
        </StyledRadio>
        <StyledRadio>
          <label>
            <input
              type="radio"
              name="date-range-radio"
              value="onemonth"
              checked={pickRange === 'onemonth'}
              onChange={changeHandler}
            />
            <StyledRadioTab>1Month</StyledRadioTab>
          </label>
        </StyledRadio>
        <StyledRadio>
          <label>
            <input
              type="radio"
              name="date-range-radio"
              value="threemonth"
              checked={pickRange === 'threemonth'}
              onChange={changeHandler}
            />
            <StyledRadioTab>3Month</StyledRadioTab>
          </label>
        </StyledRadio>
      </ul>
    </StyledRadioGroup>
  );
};

export default DateRangeRadio;
